

// document.addEventListener('click', async function(e) {

//   if (!e.target || typeof e.target.closest !== 'function') return;

//   const button = e.target.closest('.custom-add-to-cart');

//   if (!button) return;

//   e.preventDefault();

//   const form = button.closest('form');

//   if (!form) return;

//   try {

//     button.disabled = true;
//     button.innerText = 'Adding...';

//     const formData = new FormData(form);

//     // Add product
//     await fetch('/cart/add.js', {
//       method: 'POST',
//       body: formData,
//       headers: {
//         'X-Requested-With': 'XMLHttpRequest'
//       }
//     });

//     // Get updated cart
//     const cartResponse = await fetch('/cart.js');
//     const cart = await cartResponse.json();

//     const config = JSON.parse(
//       document.getElementById('cart-config').innerHTML
//     );

//     // Update theme cart properly
//     Shopify.theme.ajaxCart.updateView(config, cart);

//     // Open drawer
//     if (config.cart_action === 'drawer') {
//       Shopify.theme.ajaxCart.showDrawer(config);
//     }

//     button.innerText = 'Added';

//   } catch(error) {

//     console.error(error);

//     button.innerText = 'Error';

//   }

//   setTimeout(() => {
//     button.disabled = false;
//     button.innerText = 'Add to Cart';
//   }, 1500);

// });

document.addEventListener('click', function(e) {

  const button = e.target.closest('.custom-add-to-cart');

  // Only run for upsell add buttons
  if (!button) return;

  e.preventDefault();

  // Prevent double click
  if (button.dataset.loading === 'true') return;

  button.dataset.loading = 'true';

  const form = button.closest('form');

  if (!form) {
    button.dataset.loading = 'false';
    return;
  }

  const config = JSON.parse(
    document.getElementById('cart-config').innerHTML
  );

  Shopify.theme.ajaxCart.addToCart(
    form,
    form.parentNode,
    config,
    false
  );

  setTimeout(() => {
    button.dataset.loading = 'false';
  }, 1500);

});